export default __webpack_public_path__ + "static/signup-thumb-prizes-02fa9ff04db8ebc6eea7d5a4482a82bc.jpg";